import React from 'react'

const formatNumber = (n) => {
  if (n == null || isNaN(n)) return '—'
  return n >= 1000 ? `${Math.round(n / 1000)}K` : String(n)
}

const ServiceArea = ({ data }) => {
  const headline = data?.headline || 'Service Area Details'
  const mapImageUrl = data?.mapImageUrl || ''
  const mapCaption = data?.mapCaption || ''
  const propertyStats = data?.propertyStats || []
  const propertyLines = data?.propertyLines || []

  // Derive stats from property data if propertyStats not manually set
  const stats = propertyStats.length > 0 ? propertyStats : (() => {
    let totalAcres = 0
    let totalSqFt = 0
    propertyLines.forEach(pl => {
      if (pl.acres) totalAcres += parseFloat(pl.acres) || 0
      if (pl.sf) totalSqFt += parseFloat(pl.sf) || 0
    })
    const s = []
    if (totalAcres > 0) s.push({ value: totalAcres.toFixed(1), label: 'Acres' })
    if (totalSqFt > 0) s.push({ value: formatNumber(totalSqFt), label: 'Sq Ft' })
    return s
  })()

  // Address and APN from first parcel or data
  const address = data?.address || ''
  const apn = propertyLines[0]?.APN || data?.apn || ''

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">{headline}</div>
      <div className="proposal-section__accent-line" />

      {mapImageUrl && (
        <div className="proposal-service-area__map">
          <img src={mapImageUrl} alt="Property service area" />
        </div>
      )}

      {stats.length > 0 && (
        <div className="proposal-service-area__stats">
          {stats.map((stat, i) => (
            <div className="proposal-service-area__stat" key={i}>
              <div className="proposal-service-area__stat-value">{stat.value}</div>
              <div className="proposal-service-area__stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      )}

      {mapCaption && (
        <div className="proposal-service-area__caption">{mapCaption}</div>
      )}

      {(address || apn) && (
        <div className="proposal-service-area__details">
          {address && <div className="proposal-service-area__detail"><strong>Property Address:</strong> {address}</div>}
          {apn && <div className="proposal-service-area__detail"><strong>APN:</strong> {apn}</div>}
        </div>
      )}
    </div>
  )
}

export default ServiceArea
